/** i18n-Schlüssel für Fehlercodes, mit denen OAuth/SSO zur Login-Seite zurückleiten (?error=…). */
export function loginErrorKey(code: string | null): string {
  switch (code) {
    case 'oauth-email':
      return 'login.oauthEmailError';
    case 'oauth':
      return 'login.oauthError';
    case 'sso-not-provisioned':
      return 'login.ssoNotProvisioned';
    case 'member-inactive':
      return 'login.memberInactive';
    case 'account-locked':
      return 'login.accountLocked';
    case 'registration-closed':
      return 'login.registrationClosed';
    case 'sso-state':
      return 'login.ssoExpired';
    case 'sso-email-unverified':
      return 'login.ssoEmailUnverified';
    case 'sso-disabled':
      return 'login.ssoDisabled';
    default:
      return code?.startsWith('sso') || code?.startsWith('saml') ? 'login.ssoError' : 'login.oauthError';
  }
}
